import React from 'react'
import { confirmDialog } from 'primereact/confirmdialog'
import './maxOrderPerOrder.scss'

export function getMaxOrderQuantityPerOrder(item) {
  if (!item) return null
  const m =
    item.maxOrderQuantityPerOrder ?? item.max_order_quantity_per_order
  if (m == null || m === '') return null
  const n = Number(m)
  if (!Number.isFinite(n) || n < 1) return null
  // Integer cap; round so float serialization (e.g. 19.999…) does not floor under the real max.
  return Math.round(n)
}

/** Whole units on an order line (truncates toward zero for comparisons). */
export function normalizeLineQty(q) {
  if (q == null || q === '') return NaN
  const n = Number(q)
  if (!Number.isFinite(n)) return NaN
  return Math.trunc(n)
}

export function isOverMaxOrderQuantityPerOrder(item, qty) {
  const max = getMaxOrderQuantityPerOrder(item)
  if (max == null) return false
  const q = normalizeLineQty(qty)
  if (!Number.isFinite(q)) return false
  return q > max
}

export function MaxOrderPerOrderMessage({ itemLabel, requestedQty, maxQty }) {
  const label = itemLabel || 'This product'
  return (
    <div className='max-per-order-message'>
      <div className='max-per-order-message__symbol' aria-hidden='true'>
        <i className='pi pi-sliders-h' />
      </div>
      <div className='max-per-order-message__body'>
        <p className='max-per-order-message__line mb-0'>
          <span className='text-muted'>{label}</span>
        </p>
        <p className='max-per-order-message__line mt-2'>
          You entered <strong className='text-body'>{requestedQty}</strong> units. The
          maximum allowed per order for this item is{' '}
          <strong className='text-body'>{maxQty}</strong>.
        </p>
        <p className='max-per-order-message__hint mb-0'>
          You may enter any quantity up to and including {maxQty} units, or adjust to{' '}
          {maxQty} units.
        </p>
      </div>
    </div>
  )
}

/**
 * @param {Object} params
 * @param {string} params.itemLabel
 * @param {number} params.requestedQty
 * @param {number} params.maxQty
 * @param {() => void} params.onUseMax
 */
export function openMaxOrderPerOrderDialog({
  itemLabel,
  requestedQty,
  maxQty,
  onUseMax,
}) {
  confirmDialog({
    className: 'max-per-order-confirm-dialog',
    header: 'Maximum quantity for this product',
    message: (
      <MaxOrderPerOrderMessage
        itemLabel={itemLabel}
        requestedQty={requestedQty}
        maxQty={maxQty}
      />
    ),
    acceptLabel: `Adjust to ${maxQty} units`,
    rejectLabel: 'Go back and edit',
    acceptIcon: 'pi pi-check',
    rejectIcon: 'pi pi-arrow-left',
    rejectClassName: 'p-button-outlined p-button-secondary',
    style: { width: '100%', maxWidth: '26rem' },
    breakpoints: { '641px': '95vw' },
    dismissableMask: true,
    accept: onUseMax,
  })
}
